(function () {
  function start() {
    const root = document.querySelector('.lmu-pdp-v10');
    const form = root && root.querySelector('[data-product-form]');
    const grid = root && root.querySelector('[data-bulk-grid]');
    const addButton = root && root.querySelector('[data-bulk-add]');
    if (!root || !form || !grid || !addButton) return;
    if (root.dataset.lmuBulkOrderBound === 'true') return;
    root.dataset.lmuBulkOrderBound = 'true';

    const variantsSource = document.querySelector('[data-product-variants]');
    let variants = [];
    try { variants = variantsSource ? JSON.parse(variantsSource.textContent) : []; } catch (error) { variants = []; }
    const priceByVariant = new Map(variants.map(function (variant) { return [Number(variant.id), Number(variant.price) || 0]; }));
    let cartBrandedQuantity = 0;
    let cartMerchandiseSubtotal = 0;

    function decorationPriceFor(qty) { return qty >= 50 ? 250 : qty >= 31 ? 299 : qty >= 21 ? 349 : qty >= 16 ? 399 : 499; }
    const standardDelivery = 599;
    const freeDeliveryThreshold = 9900;
    const vatRate = 0.20;
    const logoSetupCharge = 1500;
    const money = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
    const sizeOrder = ['XXS','XS','S','M','L','XL','2XL','3XL','4XL','5XL','6XL','7XL','8XL'];

    function normaliseSize(value) {
      return String(value || '').trim().toUpperCase().replace(/^XXL$/, '2XL').replace(/^XXXL$/, '3XL').replace(/^XXXXL$/, '4XL').replace(/^XXXXXL$/, '5XL');
    }
    function sizeRank(value) {
      const index = sizeOrder.indexOf(normaliseSize(value));
      return index < 0 ? 999 : index;
    }
    function getOptionIndex(pattern) {
      const fields = Array.from(root.querySelectorAll('.lmu-pdp-v10__field'));
      for (const field of fields) {
        const label = field.querySelector('.lmu-pdp-v10__label-row label') || field.querySelector('label');
        const select = field.querySelector('select[data-option-index]');
        if (label && select && pattern.test(label.textContent || '')) return Number(select.dataset.optionIndex);
      }
      return -1;
    }

    function ensureRichSizeCards() {
      const sizeIndex = getOptionIndex(/size/i);
      if (sizeIndex < 0 || !variants.length) return;
      const colourIndex = getOptionIndex(/colou?r/i);
      const colourSelect = colourIndex >= 0 ? root.querySelector('select[data-option-index="' + colourIndex + '"]') : null;
      const selectedColour = colourSelect ? colourSelect.value : null;
      const seen = new Set();
      const rows = variants.filter(function (variant) {
        return colourIndex < 0 || variant.options[colourIndex] === selectedColour;
      }).filter(function (variant) {
        const size = variant.options[sizeIndex];
        if (seen.has(size)) return false;
        seen.add(size);
        return true;
      }).sort(function (a, b) { return sizeRank(a.options[sizeIndex]) - sizeRank(b.options[sizeIndex]); });
      if (!rows.length) { grid.innerHTML = '<p>No size variants are available for this product.</p>'; return; }

      const currentCards = Array.from(grid.children);
      const currentSignature = currentCards.map(function (card) {
        const input = card.querySelector && card.querySelector('[data-bulk-qty]');
        return normaliseSize(card.dataset && card.dataset.size || '') + ':' + (input ? String(input.dataset.variant || '') : '');
      }).join('|');
      const expectedSignature = rows.map(function (variant) {
        return normaliseSize(variant.options[sizeIndex]) + ':' + String(variant.id);
      }).join('|');
      const needsRepair =
        currentCards.length !== rows.length ||
        currentCards.some(function (node) { return node.classList && node.classList.contains('lmu-bulk__cell'); }) ||
        currentSignature !== expectedSignature;
      if (!needsRepair) return;
      grid.innerHTML = rows.map(function (variant) {
        const size = variant.options[sizeIndex];
        const available = Boolean(variant.available);
        return '<div class="lmu-size-card' + (available ? '' : ' is-unavailable') + '" data-size="' + String(size).replace(/"/g, '&quot;') + '">' +
          '<div class="lmu-size-card__head"><strong>' + size + '</strong></div>' +
          '<div class="lmu-size-card__stepper"><button type="button" data-size-minus aria-label="Decrease ' + size + ' quantity">−</button>' +
          '<input type="number" min="0" value="0" data-bulk-qty data-variant="' + variant.id + '" aria-label="' + size + ' quantity"' + (available ? '' : ' disabled') + '>' +
          '<button type="button" data-size-plus aria-label="Increase ' + size + ' quantity"' + (available ? '' : ' disabled') + '>+</button></div>' +
          '<div class="lmu-size-card__stock"><strong>' + (available ? 'Available to order' : 'Currently unavailable') + '</strong><span>' + (available ? 'Supplier stock checked at order' : 'Please choose another size') + '</span></div></div>';
      }).join('');
    }

    function syncPricingGuide() {
      const guide = root.querySelector('.lmu-volume-pricing');
      if (!guide) return;
      guide.removeAttribute('data-volume-pricing');
      guide.innerHTML = '<div class="lmu-volume-pricing__heading"><h2>Website price</h2><span>Buy online at the price shown</span></div><p>The garment price shown is the website price. No quote is needed for a standard order. For larger, multi-style or complex branded orders, you can still ask us for a quote.</p>';
    }

    const existingSummary = root.querySelector('.lmu-order-total');
    if (existingSummary) existingSummary.remove();
    const summary = document.createElement('section');
    summary.className = 'lmu-order-total';
    summary.setAttribute('aria-live', 'polite');
    summary.innerHTML = '<div class="lmu-order-total__heading"><strong>Order summary</strong><span data-order-item-count>0 garments</span></div>' +
      '<div class="lmu-order-total__minimum" data-order-branding-minimum role="alert" hidden></div><div data-order-financials>' +
      '<div class="lmu-order-total__row"><span>Garment price each</span><strong data-order-regular-unit>£0.00</strong></div>' +
      '<div class="lmu-order-total__row"><span>Garments</span><strong data-order-garment-total>£0.00</strong></div>' +
      '<div class="lmu-order-total__row" data-order-decoration-row hidden><span>Logo / decoration</span><strong data-order-decoration-total>£0.00</strong></div>' +
      '<div class="lmu-order-total__row" data-order-setup-row hidden><span>Logo setup</span><strong data-order-setup-total>£15.00</strong></div>' +
      '<div class="lmu-order-total__row"><span>Delivery</span><strong data-order-delivery>£0.00</strong></div>' +
      '<div class="lmu-order-total__row"><span>Subtotal ex VAT</span><strong data-order-subtotal-ex>£0.00</strong></div>' +
      '<div class="lmu-order-total__row"><span>VAT (20%)</span><strong data-order-vat>£0.00</strong></div>' +
      '<div class="lmu-order-total__grand"><span>Total inc VAT</span><strong data-order-total-inc>£0.00</strong></div></div>';
    addButton.parentNode.insertBefore(summary, addButton);

    function updateTotal() {
      const quantities = Array.from(grid.querySelectorAll('[data-bulk-qty]'));
      let itemCount = 0;
      let garmentTotal = 0;
      const selectedUnitPrices = [];
      quantities.forEach(function (input) {
        const quantity = Math.max(0, Number(input.value) || 0);
        const variantPrice = priceByVariant.get(Number(input.dataset.variant)) || 0;
        itemCount += quantity;
        garmentTotal += quantity * variantPrice;
        if (quantity > 0 && variantPrice > 0) selectedUnitPrices.push(variantPrice);
      });
      const minimumUnitPrice = selectedUnitPrices.length ? Math.min.apply(null, selectedUnitPrices) : 0;
      const maximumUnitPrice = selectedUnitPrices.length ? Math.max.apply(null, selectedUnitPrices) : 0;
      const regularUnitCopy = minimumUnitPrice === maximumUnitPrice ? money.format(minimumUnitPrice / 100) : money.format(minimumUnitPrice / 100) + '–' + money.format(maximumUnitPrice / 100);
      const decoration = form.querySelector('[name="properties[Decoration]"]:checked')?.value || 'No decoration';
      const projectedBrandedQuantity = decoration === 'No decoration' ? cartBrandedQuantity : cartBrandedQuantity + itemCount;
      const brandingMinimumNotMet = decoration !== 'No decoration' && projectedBrandedQuantity > 0 && projectedBrandedQuantity < 10;
      const decorationTotal = decoration === 'No decoration' ? 0 : itemCount * decorationPriceFor(projectedBrandedQuantity);
      const setupTotal = decoration === 'No decoration' || itemCount === 0 || cartBrandedQuantity > 0 ? 0 : logoSetupCharge;
      const goodsSubtotal = garmentTotal + decorationTotal + setupTotal;
      const projectedMerchandiseSubtotal = cartMerchandiseSubtotal + goodsSubtotal;
      const deliveryTotal = itemCount === 0 ? 0 : (projectedMerchandiseSubtotal >= freeDeliveryThreshold ? 0 : standardDelivery);
      const subtotalExVat = goodsSubtotal + deliveryTotal;
      const vatTotal = Math.round(goodsSubtotal * vatRate) + Math.round(deliveryTotal * vatRate);
      const totalIncVat = subtotalExVat + vatTotal;
      summary.querySelector('[data-order-item-count]').textContent = itemCount + (itemCount === 1 ? ' garment' : ' garments');
      summary.querySelector('[data-order-regular-unit]').textContent = regularUnitCopy;
      summary.querySelector('[data-order-garment-total]').textContent = money.format(garmentTotal / 100);
      summary.querySelector('[data-order-decoration-total]').textContent = money.format(decorationTotal / 100);
      summary.querySelector('[data-order-setup-total]').textContent = money.format(setupTotal / 100);
      summary.querySelector('[data-order-delivery]').textContent = itemCount === 0 ? '£0.00' : (deliveryTotal === 0 ? 'FREE' : money.format(deliveryTotal / 100));
      summary.querySelector('[data-order-subtotal-ex]').textContent = money.format(subtotalExVat / 100);
      summary.querySelector('[data-order-vat]').textContent = money.format(vatTotal / 100);
      summary.querySelector('[data-order-total-inc]').textContent = money.format(totalIncVat / 100);
      summary.querySelector('[data-order-decoration-row]').hidden = decorationTotal === 0;
      summary.querySelector('[data-order-setup-row]').hidden = setupTotal === 0;
      summary.querySelector('[data-order-financials]').hidden = brandingMinimumNotMet;
      const minimumMessage = summary.querySelector('[data-order-branding-minimum]');
      minimumMessage.hidden = !brandingMinimumNotMet;
      if (brandingMinimumNotMet) {
        const remaining = 10 - projectedBrandedQuantity;
        minimumMessage.textContent = 'Online embroidery and print require at least 10 branded garments across your basket. Add ' + remaining + ' more branded garment' + (remaining === 1 ? '' : 's') + ', or request a quote.';
      } else minimumMessage.textContent = '';
    }

    function changeSizeQuantity(event) {
      const button = event.target.closest('[data-size-minus],[data-size-plus]');
      if (!button || !root.contains(button) || button.disabled) return;
      const card = button.closest('.lmu-size-card');
      const input = card && card.querySelector('[data-bulk-qty]');
      if (!input || input.disabled) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const delta = button.hasAttribute('data-size-plus') ? 1 : -1;
      input.value = String(Math.max(0, (Number(input.value) || 0) + delta));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const optionFields = Array.from(form.querySelectorAll('.lmu-pdp-v10__field'));
    const sizeField = optionFields.find(function (field) { const label = field.querySelector('.lmu-pdp-v10__label-row label'); return label && /size/i.test(label.textContent); });
    if (sizeField) { sizeField.classList.add('lmu-pdp-v10__field--matrix-size'); form.classList.add('lmu-pdp-v10__form--uses-matrix'); }

    async function addSelectedSizes(event) {
      const clicked = event.target.closest('[data-bulk-add]');
      if (!clicked || !root.contains(clicked)) return;
      event.preventDefault(); event.stopPropagation(); event.stopImmediatePropagation();
      const selected = Array.from(grid.querySelectorAll('[data-bulk-qty]')).map(function (input) { return { id: Number(input.dataset.variant), quantity: Math.max(0, Number(input.value) || 0), input: input }; }).filter(function (item) { return item.id && item.quantity > 0; });
      if (!selected.length) { window.alert('Choose a quantity for at least one size.'); return; }
      const decoration = form.querySelector('[name="properties[Decoration]"]:checked')?.value || 'No decoration';
      const selectedQuantity = selected.reduce(function (total, item) { return total + item.quantity; }, 0);
      const projectedBrandedQuantity = decoration === 'No decoration' ? cartBrandedQuantity : cartBrandedQuantity + selectedQuantity;
      if (decoration !== 'No decoration' && projectedBrandedQuantity < 10) {
        const remaining = 10 - projectedBrandedQuantity;
        const proceed = window.confirm('Online embroidery and print require at least 10 branded garments across your basket. This selection needs ' + remaining + ' more branded garment' + (remaining === 1 ? '' : 's') + '. Add these garments to your basket so you can continue building the order?');
        if (!proceed) return;
      }
      const position = form.querySelector('[name="properties[Logo position]"]')?.value || '';
      const instructions = form.querySelector('[name="properties[Branding instructions]"]')?.value || '';
      const fileInput = form.querySelector('[name="properties[Logo file]"]');
      const logoFile = fileInput && fileInput.files ? fileInput.files[0] : null;
      const originalLabel = clicked.textContent;
      clicked.disabled = true; clicked.textContent = 'Adding selected sizes…';
      try {
        if (logoFile) {
          for (const item of selected) {
            const body = new FormData();
            body.append('id', String(item.id)); body.append('quantity', String(item.quantity));
            body.append('properties[Decoration]', decoration); body.append('properties[Logo position]', position); body.append('properties[Branding instructions]', instructions); body.append('properties[Logo file]', logoFile, logoFile.name);
            const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body });
            if (!response.ok) throw new Error('One or more sizes could not be added.');
          }
        } else {
          const items = selected.map(function (item) { return { id: item.id, quantity: item.quantity, properties: { Decoration: decoration, 'Logo position': position, 'Branding instructions': instructions } }; });
          const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) });
          if (!response.ok) throw new Error('The selected sizes could not be added.');
        }
        selected.forEach(function (item) { item.input.value = '0'; item.input.dispatchEvent(new Event('change', { bubbles: true })); });
        clicked.textContent = 'Added to basket'; window.setTimeout(function () { clicked.textContent = originalLabel; }, 1800);
      } catch (error) { window.alert(error.message || 'The selected sizes could not be added.'); clicked.textContent = originalLabel; }
      finally { clicked.disabled = false; }
    }

    document.addEventListener('click', changeSizeQuantity, true);
    document.addEventListener('click', addSelectedSizes, true);
    grid.addEventListener('input', updateTotal); grid.addEventListener('change', updateTotal);
    root.addEventListener('change', function (event) {
      if (event.target.matches('[name="properties[Decoration]"]')) updateTotal();
      if (event.target.matches('select[data-option-index]')) window.setTimeout(function () { ensureRichSizeCards(); syncPricingGuide(); updateTotal(); }, 0);
    });
    new MutationObserver(function () { ensureRichSizeCards(); updateTotal(); }).observe(grid, { childList: true });

    async function refreshCartContext() {
      try {
        const cart = window.LMUBranding && window.LMUBranding.getCart ? await window.LMUBranding.getCart() : await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
        cartBrandedQuantity = window.LMUBranding && window.LMUBranding.decoratedQuantity ? window.LMUBranding.decoratedQuantity(cart) : (cart.items || []).reduce(function (total, item) { const decoration = item.properties && item.properties.Decoration; return decoration && decoration !== 'No decoration' ? total + Number(item.quantity || 0) : total; }, 0);
        cartMerchandiseSubtotal = (cart.items || []).reduce(function(total,item){ return window.LMUBranding && window.LMUBranding.isService && window.LMUBranding.isService(item.variant_id) ? total : total + Number(item.final_line_price || 0); },0);
      } catch (error) { cartBrandedQuantity = 0; cartMerchandiseSubtotal = 0; }
      updateTotal();
    }
    window.addEventListener('lmu:item-added', function () { window.setTimeout(refreshCartContext, 0); });
    addButton.textContent = 'Add selected sizes to basket';
    ensureRichSizeCards(); syncPricingGuide(); updateTotal(); refreshCartContext();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
